import React from "react";
import PropTypes from "prop-types";
import { Form } from "antd";
import cx from "classnames";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { OrderedMap } from "immutable";
import "styles/form.css";
import { INPUT_TYPES } from "constants";
// const FormItem = Form.Item;

const FORM_FIELDS = new OrderedMap({
    open_remarks: {
        type: INPUT_TYPES.TEXTAREA,
        placeholder: "Open Remarks",
        size: "large",
        rules: [
            {
                required: true,
                message: "Open remarks are required"
            }
        ],
        onChange: null
    }
});
class OpenModalContent extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    state = {
        open_remarks: ""
    };
    onChangeRemarks = open_remarks => {
        this.props.onChange({
            open_remarks: open_remarks.target.value
        });
    };

    render() {
        return (
            <React.Fragment>
                <Form hideRequiredMark={false} className={cx("form", "br-3")}>
                    <div className={"form-row"} style={{ display: "block" }}>
                        {FORM_FIELDS.map((field, fieldName) => {
                            if (fieldName === "open_remarks") {
                                field.onChange = this.onChangeRemarks;
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )();
                        }).toList()}
                    </div>
                </Form>
            </React.Fragment>
        );
    }
}

OpenModalContent.propTypes = {
    onChange: PropTypes.func,
    form: PropTypes.object,
};

export default Form.create({})(OpenModalContent);
